import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Filter, X, ChevronDown } from "lucide-react";

const filterCategories = {
  Type: ["Internship", "Volunteering", "Job", "Bootcamp", "Full-time", "Part-time", "Seminar", "Discounts"],
  Location: ["Remote", "On-site", "Hybrid"],
  Compensation: ["Paid", "Unpaid", "Stipend"],
};

const OpportunitiesFilters = ({ filters = {}, onFiltersChange }) => {
  const [expandedCat, setExpandedCat] = useState("Type");

  const toggleFilter = (category, value) => {
    const current = filters[category] || [];
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    onFiltersChange({ ...filters, [category]: updated });
  };

  const activeCount = Object.values(filters).flat().length;

  return (
    <div className="space-y-4">
      <div className="stat-card !p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-display font-bold text-foreground flex items-center gap-2">
            <Filter className="w-4 h-4 text-secondary" /> Filters
          </h3>
          {activeCount > 0 && (
            <button onClick={() => onFiltersChange({})} className="text-xs text-secondary hover:underline cursor-pointer border-none bg-transparent font-medium">
              Clear All
            </button>
          )}
        </div>

        <div className="space-y-1">
          {Object.entries(filterCategories).map(([cat, values]) => (
            <div key={cat} className="border-b border-border/50 last:border-none pb-1 mb-1">
              <button 
                onClick={() => setExpandedCat(expandedCat === cat ? null : cat)}
                className="w-full flex items-center justify-between py-2.5 text-xs font-bold text-foreground border-none bg-transparent cursor-pointer group"
              >
                <span className="group-hover:text-secondary transition-colors">{cat}</span>
                <span className="flex items-center gap-2">
                  {(filters[cat]?.length || 0) > 0 && (
                    <span className="w-4 h-4 rounded-full bg-secondary text-white inline-flex items-center justify-center text-[9px] font-black">
                      {filters[cat].length}
                    </span>
                  )}
                  <ChevronDown className={`w-3.5 h-3.5 text-muted-foreground transition-transform duration-300 ${expandedCat === cat ? "rotate-180 text-secondary" : ""}`} />
                </span>
              </button>
              
              <AnimatePresence>
                {expandedCat === cat && (
                  <motion.div 
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="overflow-hidden"
                  >
                    <div className="flex flex-wrap gap-1.5 pb-3 pt-1">
                      {values.map((v) => {
                        const active = (filters[cat] || []).includes(v);
                        return (
                          <button
                            key={v}
                            onClick={() => toggleFilter(cat, v)}
                            className={`text-[11px] px-3 py-1.5 rounded-xl font-bold transition-all cursor-pointer border ${
                              active 
                                ? "bg-secondary text-white border-secondary shadow-sm" 
                                : "bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground border-transparent"
                            }`}
                          >
                            {v}
                          </button>
                        );
                      })}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>

      {/* Active Filter Chips */}
      {activeCount > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {Object.entries(filters).map(([cat, vals]) =>
            vals.map((v) => (
              <span key={`${cat}-${v}`} className="flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-secondary/15 text-secondary font-medium">
                {v}
                <button 
                  onClick={() => toggleFilter(cat, v)}
                  className="border-none bg-transparent cursor-pointer hover:opacity-70 p-0"
                >
                  <X className="w-3 h-3" />
                </button>
              </span>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default OpportunitiesFilters;
